'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$() {
  this.aMl = null;
  this.aMm = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$.prototype = $p;
$p.aA = (function() {
  if ((!this.aMm)) {
    this.aMl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aMm = true;
  }
  return this.aMl;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$, "app.data.data_point_types$package$IssuingBank$", ({
  G1: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssuingBank$ };
//# sourceMappingURL=app.data.data_point_types$package$-Issuing-Bank$.js.map
